export default "__VITE_ASSET__C38z3Sp2__"